import { Flex, Text } from './shared';
import { optimaChartData } from '../../../helpers/data';
import { theme } from '../design-system';
import { shouldForwardProps } from '../helpers';
import { useEffect } from 'react';

const MobileOptimaSelection = ({ selectedOptimaSize, setSelectedOptimaSize, updateStep, ...props }) => {
  const { customPropsObj } = shouldForwardProps(props);

  useEffect(() => {
    if (selectedOptimaSize) {
      const selectedItem = document.getElementById(`optima-id-${selectedOptimaSize}`)?.getBoundingClientRect();
      const container = document.getElementById('optima-selector-container')?.getBoundingClientRect();

      const selectionIsVisible = selectedItem?.top >= container?.top && selectedItem?.bottom <= container?.bottom;

      if (!selectionIsVisible)
        document.getElementById(`optima-id-${selectedOptimaSize}`)?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
    }
  }, [selectedOptimaSize]);

  return (
    <Flex column centered>
      <Flex
        column
        alignItems='center'
        borderRadius='4px'
        height='60vh'
        maxHeight='275px'
        maxWidth='700px'
        width='60vw'
        minHeight='150px'
        minWidth='325px'
        backgroundColor='#FBFBFB'
        border='0.5px solid #cccccc'
        boxShadow='inset 0px -0.5px 0px #EEEEEE'
        position='relative'
        overflow='auto'
        scrollSnapType='y mandatory'
        scrollSnapStop='always'
        {...customPropsObj}
        id='optima-selector-container'
      >
        {optimaChartData.map((optimaSize) => {
          return (
            <Flex
              width='100%'
              padding='1rem'
              centered
              key={`optima-id-${optimaSize.id}`}
              id={`optima-id-${optimaSize.id}`}
              scrollSnapAlign='start'
              onClick={props.onClick ? props.onClick : () => setSelectedOptimaSize(optimaSize.id)}
              backgroundColor={selectedOptimaSize === optimaSize.id ? '#e0dfdf' : 'transparent'}
              border={`1px solid ${selectedOptimaSize === optimaSize.id ? theme.colors.primary : '#fbfbfb'}`}
            >
              <Text>{optimaSize.value}</Text>
            </Flex>
          );
        })}
      </Flex>
    </Flex>
  );
};

export default MobileOptimaSelection;
